
<template>
    <div class="center">
      <vs-dialog v-model="active" @close="getCerrar" prevent-close>
        <template #header>
          <h4 class="not-margin">
            Asignar beca
          </h4>
        </template>

        <div>
            <vs-row>
                <vs-col w="12">
                    <label for="categorias" class="labelInput">
                        Categorias
                    </label>
                    <vs-select :loading="loadingCategoria" filter class="aqui pt-0" id="categorias" placeholder="Seleccionar categoría" :key="categoriaId" v-model="categoria" :disabled="!categorias.length">
                        <template #message-danger v-if="errorFields.includes('categoria')">
                            Requerido
                        </template>
                        <vs-option v-for="option in categorias" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col w="12">
                    <label for="becas" class="labelInput">
                        Beca
                    </label>
                    <vs-select :loading="loadingBeca" filter class="aqui pt-0" id="becas" placeholder="Seleccionar beca" :key="becaId" v-model="beca" :disabled="!becas.length">
                        <template #message-danger v-if="errorFields.includes('beca')">
                            Requerido
                        </template>
                        <vs-option v-for="option in becas" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="getCerrar()">
                Cancelar
                </vs-button>
                <vs-button :disabled="!beca" success @click="postAsignarBecaMasivo()">
                Aceptar
                </vs-button>
            </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import servicios from '../../../../../api/requests/servicios'
export default {
    props:[
    'value',
    'selected',
    'cicloEscolar',
    'institucion'
    ],
    data(){
        return{
        active: false,
        categoria: '',
        categorias: [],
        categoriaId: (new Date()).getTime(),
        loadingCategoria: false,
        beca: '',
        becas: [],
        becaId: (new Date()).getTime(),
        loadingBeca: false,
        errorFields: []
        }
    },
    methods: {
        async getCategoriasAsignarBeca(){
            try{
                this.loadingCategoria = true
                const { data: response } = await servicios.getCategoriasAsignarBeca()
                this.categorias = this.getEliminarNameKey(response)
                this.categoriaId = (new Date()).getTime()
                this.loadingCategoria = false
            }catch(error){
                console.log(error)
            }
        },
        async getBecaAsignarBeca(){
            if(this.categoria){
                try{
                    this.loadingBeca = true
                    const { data: response } = await servicios.getBecaAsignarBeca(this.institucion, this.categoria)
                    this.becas = this.getEliminarNameKey(response)
                    this.becaId = (new Date()).getTime()
                    this.loadingBeca = false
                }catch(error){
                    console.log(error)
                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        async postAsignarBecaMasivo(){
            const loading = this.$vs.loading()
            try{
                const idPersona = this.selected.map(s => s.persona_id)
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    beca_id: this.beca,
                    personas_ids: idPersona
                }
                const response = await servicios.postAsignarBecaMasivo(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa.',
                    text: 'Se ha asignado la beca correctamente.'
                })
                this.$emit('refreshTabla')
                loading.close()
                this.getCerrar()
            }catch(error){
                console.log(error)
                loading.close()
                this.getCerrar()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal.',
                    text: 'Favor de ponerse en contacto con el administrador.'
                })
            }
        },
        getCerrar(){
            this.active = false
            this.categoria = ''
            this.beca = ''
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        selected(){
            this.getCategoriasAsignarBeca()
        },
        categoria(){
            this.getBecaAsignarBeca()
        }
    }
}
</script>